import { IPropertyPresentable, instanceOfIPropertyPresentable } from "../../../../base/domain/system/edit";
import { ITableIndex } from "../../../../documaker/domain/format/objects";

export interface ITableIndexPropertyPresentable {
  tableIndex(): IPropertyPresentable<ITableIndex>;
}

export function instanceOfITableIndexPropertyPresentable(instance: any): instance is ITableIndexPropertyPresentable {
  return instance
      && instance.tableIndex
      && instanceOfIPropertyPresentable<ITableIndex>(instance.tableIndex());
}
